import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { LegalFees } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface DeleteLegalFeesInvoiceRequest {
    engagementId: number;
}

export const DeleteLegalFeesInvoice = createAsyncThunk(
    'flowOfFunds/deleteLegalFeesInvoice',
    async (params: DeleteLegalFeesInvoiceRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.delete(
                `/api/flowOfFunds/${params.engagementId}/legalFees/invoice`
            );

            if (response.status !== 200) {
                throw new Error('Failed to delete the invoice');
            }

            return response.data as LegalFees;
        } catch (error) {
            createNotification('Could not delete the invoice.', 'error');
            throw error;
        }
    }
);
